import { urlToBase64 } from "src/app/utils/utils.common";

export async function dailyVehicleInspection(data, vehicle, weekStart, timePipe) {
    let days = {};
    if (data && data.length) {
      data.forEach(inspection => {
        days[inspection.day] = inspection;
      });
    }
    //object.hasOwnProperty('0');
    console.log('Test-1:', days);
    console.log("data here", data);
    return {
      info: {
        title: 'OEMS',
        author: 'Haseeb Rao',
        subject: 'Daily vehicle inspection',
        keywords: 'Vehicle Inspection Report ',
      },
      //   userPassword: '123456',
      pageSize: 'A4',
      pageMargins: [10, 20, 10, 0],
      content: [
  
        {
  
          table: {
            widths: ['25%', '50%', '25%',],
            body: [
  
              [{
                text: [{
                  text: 'Form\n ',
                  style: 'small',
                },
                {
                  text: 'ODA0008\n',
                  fontSize: 14,
                  bold: true
                },
                {
                  text: '(Rev. 02/01/2019)\n',
                  style: 'small',
                },
                {
                  text: 'Ohio Department of Aging',
                  style: 'small',
                },
                ],
                border: [0, 0, 0, 1],
                margin: [0, 0, 0, 0],
                fontSize: '14',
  
              },
              {
                text: 'DAILY VEHICLE INSPECTION',
                border: [1, 0, 1, 1],
                margin: [0, 12, 0, 0],
                fontSize: '14',
                bold: 'true',
                alignment: 'center',
              },
              {
                text: '',
                border: [0, 0, 0, 1],
                margin: [0, 20, 0, 0],
                fontSize: '12',
                alignment: 'center',
  
  
              },
              ],
  
  
  
  
            ]
          },
          margin: [0, 0, 0, 80],
        },
        {
          // 	layout: 'noBorders',
          table: {
  
            widths: ['33.3%', '33.3%', '33.3%'],
            body: [
              [{
                text: 'VEHICLE ID',
                fillColor: '#cdcdcd',
                border: [1, 1, 1, 1],
                alignment: 'center',
                style: 'small',
                margin: 0,
  
                // 		borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
  
              {
                text: 'LAST SIX DIGITS OF VIN',
                fillColor: '#cdcdcd',
                style: 'small',
                alignment: 'center',
                margin: 0,
                border: [1, 1, 1, 1],
                // 		borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
  
              {
                text: 'MAKE & MODEL',
                fillColor: '#cdcdcd',
                style: 'small',
                alignment: 'center',
                margin: 0,
                border: [1, 1, 1, 1],
                // 		borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
  
  
              ],
              [{
                text: vehicle.driverCarNumber ? vehicle.driverCarNumber : '',
                fillColor: '#f1f4ff',
                border: [1, 0, 1, 1],
                alignment: 'center',
                style: 'small',
                margin: 0,
  
                borderColor: ['#000000', '#000000', '#000000', '#000000']
              },
  
              {
                text: data[0].vinLastNum ? data[0].vinLastNum : '',
                fillColor: '#f1f4ff',
                style: 'small',
                alignment: 'center',
                margin: 0,
                border: [1, 0, 1, 1],
                // 		borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
  
              {
                text: data[0].makeModel ? data[0].makeModel : '',
                fillColor: '#f1f4ff',
                style: 'small',
                alignment: 'center',
                margin: [0, 2, 0, 2],
                border: [1, 0, 1, 1],
                // 		borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
  
  
              ],
  
            ]
          },
          margin: [0, -75, 0, 0],
          // 		layout: 'noBorders',
        },
        // ---THE PROVIDER SHALL---
        {
          // 	layout: 'noBorders',
          table: {
  
            widths: ['100%'],
            body: [
              [{
                text: 'THE PROVIDER SHALL INSPECT THE FOLLOWING ITEMS BEFORE PROVIDING THE FIRST TRIP OF THE DAY',
                style: 'small',
                alignment: 'center',
                bold: 'true',
                margin: [0, 0, 0, 0],
                border: [0, 0, 0, 0],
                borderColor: ['#f3f4f6', '#f3f4f6', '#f3f4f6', '#f3f4f6']
              },
  
  
  
              ],
  
  
            ]
          },
          margin: [0, 0, 0, 0],
          // 		layout: 'noBorders',
        },
        // 		Sunday,  Monday
        {
          table: {
  
            widths: ['44%', '8%', '8%', '8%', '8%', '8%', '8%', '8%'],
            // heights:8,
            body: [
              // 'WEEK OF _ _ /_ _ /_ _ _ _',
              // level Two
              [
  
                {
                  text: 'WEEK OF ' + timePipe.transform(weekStart, "MM/DD/YYYY"),
                  fillColor: '#cdcdcd',
                  alignment: 'center',
                  margin: [0, 0, 0, 0],
                  style: 'small',
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
  
                {
                  table: {
                    widths: ['100%'],
  
                    body: [
                      [
                        {
                          text: 'SUN',
                          border: [0, 0, 0, 0],
                          margin: [0, 0, 0, 0],
                          fontSize: '6',
                          // 			style: 'small',
                          alignment: 'center'
                        },
                      ],
  
                    ]
                  },
  
                  // 		text: '_ _ _ , _ _ _',
                  fillColor: '#9bcdfd',
                  // 		alignment:'center',
                  // 		bold:'true',
  
                  margin: [0, -2, 0, -4],
                  // 			style: 'small',
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
                {
                  table: {
                    widths: ['100%'],
  
                    body: [
                      [
                        {
                          text: 'MON',
                          border: [0, 0, 0, 0],
                          margin: [0, 0, 0, 0],
                          fontSize: '6',
                          // 			style: 'small',
                          alignment: 'center'
                        },
                      ],
  
                    ]
                  },
  
                  // 		text: '_ _ _ , _ _ _',
                  fillColor: '#9bcdfd',
                  // 		alignment:'center',
                  // 		bold:'true',
  
                  margin: [0, -2, 0, -4],
                  // 			style: 'small',
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
                {
                  table: {
                    widths: ['100%'],
  
                    body: [
                      [
                        {
                          text: 'TUES',
                          border: [0, 0, 0, 0],
                          margin: [0, 0, 0, 0],
                          fontSize: '6',
                          // 			style: 'small',
                          alignment: 'center'
                        },
                      ],
  
                    ]
                  },
  
                  // 		text: '_ _ _ , _ _ _',
                  fillColor: '#9bcdfd',
                  // 		alignment:'center',
                  // 		bold:'true',
  
                  margin: [0, -2, 0, -4],
                  // 			style: 'small',
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
                {
                  table: {
                    widths: ['100%'],
  
                    body: [
                      [
                        {
                          text: 'WED',
                          border: [0, 0, 0, 0],
                          margin: [0, 0, 0, 0],
                          fontSize: '6',
                          // 			style: 'small',
                          alignment: 'center'
                        },
                      ],
  
                    ]
                  },
  
                  // 		text: '_ _ _ , _ _ _',
                  fillColor: '#9bcdfd',
                  // 		alignment:'center',
                  // 		bold:'true',
  
                  margin: [0, -2, 0, -4],
                  // 			style: 'small',
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
                {
                  table: {
                    widths: ['100%'],
  
                    body: [
                      [
                        {
                          text: 'THURS',
                          border: [0, 0, 0, 0],
                          margin: [0, 0, 0, 0],
                          fontSize: '6',
                          // 			style: 'small',
                          alignment: 'center'
                        },
                      ],
  
                    ]
                  },
  
                  // 		text: '_ _ _ , _ _ _',
                  fillColor: '#9bcdfd',
                  // 		alignment:'center',
                  // 		bold:'true',
  
                  margin: [0, -2, 0, -4],
                  // 			style: 'small',
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
                {
                  table: {
                    widths: ['100%'],
  
                    body: [
                      [
                        {
                          text: 'FRI',
                          border: [0, 0, 0, 0],
                          margin: [0, 0, 0, 0],
                          fontSize: '6',
                          // 			style: 'small',
                          alignment: 'center'
                        },
                      ],
  
                    ]
                  },
  
                  // 		text: '_ _ _ , _ _ _',
                  fillColor: '#9bcdfd',
                  // 		alignment:'center',
                  // 		bold:'true',
  
                  margin: [0, -2, 0, -4],
                  // 			style: 'small',
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
                {
                  table: {
                    widths: ['100%'],
  
                    body: [
                      [
                        {
                          text: 'SAT',
                          border: [0, 0, 0, 0],
                          margin: [0, 0, 0, 0],
                          fontSize: '6',
                          // 			style: 'small',
                          alignment: 'center'
                        },
                      ],
  
                    ]
                  },
  
                  // 		text: '_ _ _ , _ _ _',
                  fillColor: '#9bcdfd',
                  // 		alignment:'center',
                  // 		bold:'true',
  
                  margin: [0, -2, 0, -4],
                  // 			style: 'small',
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
  
              ],
  
  
            ]
          },
          margin: [0, 0, 0, 0],
          border: [0, 0, 0, 0]
        },
        // 		Odometer Reading
        {
          table: {
  
            widths: ['44%', '8%', '8%', '8%', '8%', '8%', '8%', '8%'],
            body: [
  
              // level Two
              [
  
                {
                  text: 'ODOMETER READING',
                  fillColor: '#cdcdcd',
  
                  // 		bold:'true',
                  alignment: 'center',
                  margin: [0, 0, 0, 0],
                  style: 'small',
  
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
                {
                  table: {
                    widths: ['100%'],
  
                    body: [
                      [
                        {
                          text: days.hasOwnProperty('0') ? (days['0'].odmReading ? days['0'].odmReading : '----') : '----',
                          border: [0, 0, 0, 0],
                          margin: [0, 0, 0, 0],
                          fontSize: '6',
                          // 			style: 'small',
                          alignment: 'center'
                        },
                      ],
  
                    ]
                  },
  
                  // 		text: '_ _ _ , _ _ _',
                  fillColor: '#f1d5c2',
                  // 		alignment:'center',
                  // 		bold:'true',
  
                  margin: [0, -2, 0, -4],
                  // 			style: 'small',
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
                {
                  table: {
                    widths: ['100%'],
  
                    body: [
                      [
                        {
                          text: days.hasOwnProperty('1') ? (days['1'].odmReading ? days['1'].odmReading : '----') : '----',
                          border: [0, 0, 0, 0],
                          margin: [0, 0, 0, 0],
                          fontSize: '6',
                          // 			style: 'small',
                          alignment: 'center'
                        },
                      ],
  
                    ]
                  },
  
                  // 		text: '_ _ _ , _ _ _',
                  fillColor: '#f1d5c2',
                  // 		alignment:'center',
                  // 		bold:'true',
  
                  margin: [0, -2, 0, -4],
                  // 			style: 'small',
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
                {
                  table: {
                    widths: ['100%'],
  
                    body: [
                      [
                        {
                          text: days.hasOwnProperty('2') ? (days['2'].odmReading ? days['2'].odmReading : '----') : '----',
                          border: [0, 0, 0, 0],
                          margin: [0, 0, 0, 0],
                          fontSize: '6',
                          // 			style: 'small',
                          alignment: 'center'
                        },
                      ],
  
                    ]
                  },
  
                  // 		text: '_ _ _ , _ _ _',
                  fillColor: '#f1d5c2',
                  // 		alignment:'center',
                  // 		bold:'true',
  
                  margin: [0, -2, 0, -4],
                  // 			style: 'small',
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
                {
                  table: {
                    widths: ['100%'],
  
                    body: [
                      [
                        {
                          text: days.hasOwnProperty('3') ? (days['3'].odmReading ? days['3'].odmReading : '----') : '----',
                          border: [0, 0, 0, 0],
                          margin: [0, 0, 0, 0],
                          fontSize: '6',
                          // 			style: 'small',
                          alignment: 'center'
                        },
                      ],
  
                    ]
                  },
  
                  // 		text: '_ _ _ , _ _ _',
                  fillColor: '#f1d5c2',
                  // 		alignment:'center',
                  // 		bold:'true',
  
                  margin: [0, -2, 0, -4],
                  // 			style: 'small',
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
                {
                  table: {
                    widths: ['100%'],
  
                    body: [
                      [
                        {
                          text: days.hasOwnProperty('4') ? (days['4'].odmReading ? days['4'].odmReading : '----') : '----',
                          border: [0, 0, 0, 0],
                          margin: [0, 0, 0, 0],
                          fontSize: '6',
                          // 			style: 'small',
                          alignment: 'center'
                        },
                      ],
  
                    ]
                  },
  
                  // 		text: '_ _ _ , _ _ _',
                  fillColor: '#f1d5c2',
                  // 		alignment:'center',
                  // 		bold:'true',
  
                  margin: [0, -2, 0, -4],
                  // 			style: 'small',
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
                {
                  table: {
                    widths: ['100%'],
  
                    body: [
                      [
                        {
                          text: days.hasOwnProperty('5') ? (days['5'].odmReading ? days['5'].odmReading : '----') : '----',
                          border: [0, 0, 0, 0],
                          margin: [0, 0, 0, 0],
                          fontSize: '6',
                          // 			style: 'small',
                          alignment: 'center'
                        },
                      ],
  
                    ]
                  },
  
                  // 		text: '_ _ _ , _ _ _',
                  fillColor: '#f1d5c2',
                  // 		alignment:'center',
                  // 		bold:'true',
  
                  margin: [0, -2, 0, -4],
                  // 			style: 'small',
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
                {
                  table: {
                    widths: ['100%'],
  
                    body: [
                      [
                        {
                          text: days.hasOwnProperty('6') ? (days['6'].odmReading ? days['6'].odmReading : '----') : '----',
                          border: [0, 0, 0, 0],
                          margin: [0, 0, 0, 0],
                          fontSize: '6',
                          // 			style: 'small',
                          alignment: 'center'
                        },
                      ],
  
                    ]
                  },
  
                  // 		text: '_ _ _ , _ _ _',
                  fillColor: '#f1d5c2',
                  // 		alignment:'center',
                  // 		bold:'true',
  
                  margin: [0, -2, 0, -4],
                  // 			style: 'small',
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
  
              ],
  
  
            ]
          },
          margin: [0, 0, 0, 0],
          border: [0, 0, 0, 0]
        },
        // 		INSPECTION ITEMS
        {
          table: {
  
            widths: ['44%', '8%', '8%', '8%', '8%', '8%', '8%', '8%'],
            body: [
  
              // level Two
              [
  
                {
                  text: 'INSPECTION ITEMS',
                  fillColor: '#cdcdcd',
  
                  // 		bold:'true',
                  alignment: 'center',
                  margin: [0, 0, 0, 0],
                  style: 'small',
  
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
  
                {
                  table: {
                    widths: ['50%', '50%'],
  
                    body: [
                      [{
                        text: 'Yes',
                        border: [0, 0, 1, 0],
                        fontSize: '6',
                      },
                      {
                        text: 'No',
                        border: [0, 0, 0, 0],
                        fontSize: '6',
                      },
                      ],
  
                    ]
                  },
                  fillColor: '#cdcdcd',
                  margin: [-3, -3, -3, -3],
                  fontSize: '6',
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
                {
                  table: {
                    widths: ['50%', '50%'],
  
                    body: [
                      [{
                        text: 'Yes',
                        border: [0, 0, 1, 0],
                        fontSize: '6',
                      },
                      {
                        text: 'No',
                        border: [0, 0, 0, 0],
                        fontSize: '6',
                      },
                      ],
  
                    ]
                  },
                  fillColor: '#cdcdcd',
                  margin: [-3, -3, -3, -3],
                  fontSize: '6',
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
                {
                  table: {
                    widths: ['50%', '50%'],
  
                    body: [
                      [{
                        text: 'Yes',
                        border: [0, 0, 1, 0],
                        fontSize: '6',
                      },
                      {
                        text: 'No',
                        border: [0, 0, 0, 0],
                        fontSize: '6',
                      },
                      ],
  
                    ]
                  },
                  fillColor: '#cdcdcd',
                  margin: [-3, -3, -3, -3],
                  fontSize: '6',
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
                {
                  table: {
                    widths: ['50%', '50%'],
  
                    body: [
                      [{
                        text: 'Yes',
                        border: [0, 0, 1, 0],
                        fontSize: '6',
                      },
                      {
                        text: 'No',
                        border: [0, 0, 0, 0],
                        fontSize: '6',
                      },
                      ],
  
                    ]
                  },
                  fillColor: '#cdcdcd',
                  margin: [-3, -3, -3, -3],
                  fontSize: '6',
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
                {
                  table: {
                    widths: ['50%', '50%'],
  
                    body: [
                      [{
                        text: 'Yes',
                        border: [0, 0, 1, 0],
                        fontSize: '6',
                      },
                      {
                        text: 'No',
                        border: [0, 0, 0, 0],
                        fontSize: '6',
                      },
                      ],
  
                    ]
                  },
                  fillColor: '#cdcdcd',
                  margin: [-3, -3, -3, -3],
                  fontSize: '6',
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
                {
                  table: {
                    widths: ['50%', '50%'],
  
                    body: [
                      [{
                        text: 'Yes',
                        border: [0, 0, 1, 0],
                        fontSize: '6',
                      },
                      {
                        text: 'No',
                        border: [0, 0, 0, 0],
                        fontSize: '6',
                      },
                      ],
  
                    ]
                  },
                  fillColor: '#cdcdcd',
                  margin: [-3, -3, -3, -3],
                  fontSize: '6',
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
                {
                  table: {
                    widths: ['50%', '50%'],
  
                    body: [
                      [{
                        text: 'Yes',
                        border: [0, 0, 1, 0],
                        fontSize: '6',
                      },
                      {
                        text: 'No',
                        border: [0, 0, 0, 0],
                        fontSize: '6',
                      },
                      ],
  
                    ]
                  },
                  fillColor: '#cdcdcd',
                  margin: [-3, -3, -3, -3],
                  fontSize: '6',
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
  
              ],
  
  
            ]
          },
          margin: [0, 0, 0, 0],
          border: [0, 0, 0, 0]
        },
        //    	Exterior
        {
          table: {
  
            widths: ['10.4%', '89.6%'],
            body: [
  
  
              [
  
                {
                  text: 'EXTERIOR',
                  fillColor: '#fecc9d',
                  margin: [0, 17, 0, 0],
  
                  // 		bold:'true',
                  alignment: 'center',
                  layout: 'verticalAlign',
                  border: [1, 0, 1, 1],
                  style: 'small',
  
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
                {
                  table: {
  
                    widths: ['31.6%', '68.8%'],
  
                    body: [
  
                      // Ground under vehicle free of leaked fluids?
                      [
  
                        {
                          text: 'Ground under vehicle free of leaked fluids?',
                          fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
  
  
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].exterior.leakFluids ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].exterior.leakFluids ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].exterior.leakFluids ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].exterior.leakFluids ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].exterior.leakFluids ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].exterior.leakFluids ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].exterior.leakFluids ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].exterior.leakFluids ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].exterior.leakFluids ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].exterior.leakFluids ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].exterior.leakFluids ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].exterior.leakFluids ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].exterior.leakFluids ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].exterior.leakFluids ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
  
  
  
  
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
                      ],
                      // 	Auto body free of new damage?
                      [
                        {
                          text: 'Auto body free of new damage?',
                          fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].exterior.bodyDamage ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].exterior.bodyDamage ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].exterior.bodyDamage ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].exterior.bodyDamage ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].exterior.bodyDamage ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].exterior.bodyDamage ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].exterior.bodyDamage ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].exterior.bodyDamage ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].exterior.bodyDamage ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].exterior.bodyDamage ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].exterior.bodyDamage ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].exterior.bodyDamage ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].exterior.bodyDamage ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].exterior.bodyDamage ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
  
  
  
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
  
                      ],
                      // 	Clean windows and mirrors?
                      [
                        {
                          text: 'Clean windows and mirrors?',
                          fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].exterior.cleanWin ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].exterior.cleanWin ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].exterior.cleanWin ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].exterior.cleanWin ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].exterior.cleanWin ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].exterior.cleanWin ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].exterior.cleanWin ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].exterior.cleanWin ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].exterior.cleanWin ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].exterior.cleanWin ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].exterior.cleanWin ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].exterior.cleanWin ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].exterior.cleanWin ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].exterior.cleanWin ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
  
                      ],
                      // 	Windshield wipers/washers appear OK?
                      [
                        {
                          text: 'Windshield wipers/washers appear OK?',
                          fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].exterior.iswiperOk ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].exterior.iswiperOk ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].exterior.iswiperOk ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].exterior.iswiperOk ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].exterior.iswiperOk ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].exterior.iswiperOk ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].exterior.iswiperOk ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].exterior.iswiperOk ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].exterior.iswiperOk ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].exterior.iswiperOk ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].exterior.iswiperOk ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].exterior.iswiperOk ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].exterior.iswiperOk ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].exterior.iswiperOk ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
                      ],
  
                    ]
                  },
                  margin: [-4, -4, -4, -4],
                  border: [0, 0, 0, 0]
                },
  
              ],
  
  
            ]
          },
          margin: [0, 0, 0, 0],
        },
        // 		--Tires Appears Ok---
        {
          table: {
  
            widths: ['10.4%', '89.6%'],
            // heights: 310,
            body: [
  
  
              [
  
                {
                  text: 'TIRES APPEAR ?',
                  // 			fillColor: '#fecc9d',
                  margin: [0, 5, 0, 0],
  
                  // 		bold:'true',
                  alignment: 'center',
                  layout: 'verticalAlign',
                  border: [1, 0, 1, 1],
                  style: 'small',
  
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
                {
                  table: {
  
                    widths: ['31.6%', '68.8%'],
  
                    body: [
  
                      // Ground under vehicle free of leaked fluids?
                      [
  
                        {
                          text: 'Properly inflated?',
                          // 		fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].tires.pInflated ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].tires.pInflated ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].tires.pInflated ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].tires.pInflated ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].tires.pInflated ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].tires.pInflated ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].tires.pInflated ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].tires.pInflated ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].tires.pInflated ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].tires.pInflated ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].tires.pInflated ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].tires.pInflated ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].tires.pInflated ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].tires.pInflated ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
                      ],
                      // 	Auto body free of new damage?
                      [
                        {
                          text: 'Free of visible damage?',
                          // 		fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
  
  
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].tires.tireDamage ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].tires.tireDamage ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].tires.tireDamage ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].tires.tireDamage ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].tires.tireDamage ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].tires.tireDamage ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].tires.tireDamage ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].tires.tireDamage ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].tires.tireDamage ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].tires.tireDamage ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].tires.tireDamage ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].tires.tireDamage ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].tires.tireDamage ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].tires.tireDamage ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
  
  
  
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
  
                      ],
  
                    ]
                  },
                  margin: [-4, -2, -4, -4],
                  border: [0, 0, 0, 0]
                },
  
              ],
  
  
            ]
          },
          margin: [0, 0, 0, 0],
        },
        // 		-------Under the hood---- 
        {
          table: {
  
            widths: ['10.4%', '89.6%'],
            body: [
  
  
              [
  
                {
                  text: 'UNDER THE HOOD The provider shall check oil and belts before starting vehicle.',
                  fillColor: '#fecc9d',
                  margin: [0, 0, 0, 0],
  
                  // 		bold:'true',
                  alignment: 'center',
                  layout: 'verticalAlign',
                  border: [1, 0, 1, 1],
                  style: 'small',
  
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
                {
                  table: {
  
                    widths: ['31.6%', '68.8%'],
  
                    body: [
  
                      // Ground under vehicle free of leaked fluids?
                      [
  
                        {
                          text: 'Adequate clean oil?',
                          fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].hood.cleanOil ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].hood.cleanOil ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].hood.cleanOil ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].hood.cleanOil ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].hood.cleanOil ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].hood.cleanOil ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].hood.cleanOil ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].hood.cleanOil ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].hood.cleanOil ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].hood.cleanOil ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].hood.cleanOil ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].hood.cleanOil ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].hood.cleanOil ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].hood.cleanOil ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
                      ],
                      // 	Auto body free of new damage?
                      [
                        {
                          text: 'Hoses appear OK? (e.g., no cracks, leaks)',
                          fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
  
  
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].hood.hoses ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].hood.hoses ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].hood.hoses ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].hood.hoses ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].hood.hoses ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].hood.hoses ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].hood.hoses ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].hood.hoses ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].hood.hoses ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].hood.hoses ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].hood.hoses ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].hood.hoses ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].hood.hoses ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].hood.hoses ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
  
  
  
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
  
                      ],
                      // 	Clean windows and mirrors?
                      [
                        {
                          text: 'Belts appear OK? (e.g., no fraying)',
                          fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
  
  
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].hood.belts ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].hood.belts ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].hood.belts ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].hood.belts ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].hood.belts ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].hood.belts ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].hood.belts ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].hood.belts ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].hood.belts ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].hood.belts ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].hood.belts ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].hood.belts ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].hood.belts ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].hood.belts ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
  
  
  
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
  
                      ],
                      // 	Windshield wipers/washers appear OK?
                      [
                        {
                          text: 'Adequate windshield washer fluid?',
                          fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
  
  
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].hood.washerfluid ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].hood.washerfluid ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].hood.washerfluid ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].hood.washerfluid ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].hood.washerfluid ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].hood.washerfluid ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].hood.washerfluid ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].hood.washerfluid ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].hood.washerfluid ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].hood.washerfluid ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].hood.washerfluid ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].hood.washerfluid ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].hood.washerfluid ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].hood.washerfluid ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
  
  
  
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
                      ],
  
                    ]
                  },
                  margin: [-4, -4, -4, -4],
                  border: [0, 0, 0, 0]
                },
  
              ],
  
  
            ]
          },
          margin: [0, 0, 0, 0],
        },
        // 		---Item Store in vehicle---
        {
          table: {
  
            widths: ['10.4%', '89.6%'],
            body: [
  
  
              [
  
                {
                  text: 'ITEMS STORED IN VEHICLE?',
                  // 			fillColor: '#fecc9d',
                  margin: [0, 30, 0, 0],
  
                  // 		bold:'true',
                  alignment: 'center',
                  layout: 'verticalAlign',
                  border: [1, 0, 1, 1],
                  style: 'small',
  
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
                {
                  table: {
  
                    widths: ['31.6%', '68.8%'],
  
                    body: [
  
                      // Ground under vehicle free of leaked fluids?
                      [
  
                        {
                          text: 'Current, valid insurance ID card?',
                          // 		fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].storage.idCard ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].storage.idCard ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].storage.idCard ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].storage.idCard ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].storage.idCard ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].storage.idCard ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].storage.idCard ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].storage.idCard ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].storage.idCard ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].storage.idCard ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].storage.idCard ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].storage.idCard ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].storage.idCard ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].storage.idCard ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
                      ],
                      // 	Auto body free of new damage?
                      [
                        {
                          text: 'Current, valid vehicle registration?',
                          // 		fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].storage.vehRegistration ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].storage.vehRegistration ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].storage.vehRegistration ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].storage.vehRegistration ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].storage.vehRegistration ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].storage.vehRegistration ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].storage.vehRegistration ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].storage.vehRegistration ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].storage.vehRegistration ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].storage.vehRegistration ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].storage.vehRegistration ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].storage.vehRegistration ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].storage.vehRegistration ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].storage.vehRegistration ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
  
                      ],
  
                      [
                        {
                          text: 'Biohazard kit?',
                          // 		fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].storage.bioKit ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].storage.bioKit ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].storage.bioKit ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].storage.bioKit ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].storage.bioKit ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].storage.bioKit ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].storage.bioKit ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].storage.bioKit ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].storage.bioKit ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].storage.bioKit ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].storage.bioKit ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].storage.bioKit ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].storage.bioKit ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].storage.bioKit ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
  
                      ],
  
                      [
                        {
                          text: 'First-aid kit?',
                          // 		fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].storage.aidKit ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].storage.aidKit ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].storage.aidKit ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].storage.aidKit ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].storage.aidKit ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].storage.aidKit ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].storage.aidKit ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].storage.aidKit ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].storage.aidKit ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].storage.aidKit ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].storage.aidKit ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].storage.aidKit ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].storage.aidKit ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].storage.aidKit ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
  
                      ],
  
                      [
                        {
                          text: 'Seatbelt cutter?',
                          // 		fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].storage.beltCutter ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].storage.beltCutter ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].storage.beltCutter ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].storage.beltCutter ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].storage.beltCutter ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].storage.beltCutter ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].storage.beltCutter ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].storage.beltCutter ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].storage.beltCutter ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].storage.beltCutter ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].storage.beltCutter ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].storage.beltCutter ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].storage.beltCutter ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].storage.beltCutter ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
  
                      ],
  
                      [
                        {
                          text: 'Flares or reflective triangles?',
                          // 		fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].storage.flares ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].storage.flares ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].storage.flares ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].storage.flares ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].storage.flares ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].storage.flares ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].storage.flares ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].storage.flares ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].storage.flares ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].storage.flares ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].storage.flares ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].storage.flares ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].storage.flares ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].storage.flares ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
  
                      ],
  
                      [
                        {
                          text: 'Fire extinguisher?',
                          // 		fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].storage.fireextinguisher ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].storage.fireextinguisher ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].storage.fireextinguisher ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].storage.fireextinguisher ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].storage.fireextinguisher ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].storage.fireextinguisher ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].storage.fireextinguisher ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].storage.fireextinguisher ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].storage.fireextinguisher ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].storage.fireextinguisher ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].storage.fireextinguisher ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].storage.fireextinguisher ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].storage.fireextinguisher ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].storage.fireextinguisher ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
  
                      ],
  
                      [
                        {
                          text: 'Blanket? (winter only)',
                          // 		fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].storage.blanket ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].storage.blanket ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].storage.blanket ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].storage.blanket ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].storage.blanket ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].storage.blanket ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].storage.blanket ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].storage.blanket ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].storage.blanket ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].storage.blanket ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].storage.blanket ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].storage.blanket ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1f4ff',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].storage.blanket ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].storage.blanket ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
  
                      ],
  
                    ]
                  },
                  margin: [-4, -2, -4, -4],
                  border: [0, 0, 0, 0]
                },
  
              ],
  
  
            ]
          },
          margin: [0, 0, 0, 0],
        },
  
        // 		---Item Inspected from the interior---
        {
          table: {
  
            widths: ['10.4%', '89.6%'],
            body: [
  
  
              [
  
                {
                  text: 'ITEMS INSPECTED FROM THE INTERIOR APPEAR OK?',
                  fillColor: '#fecc9d',
                  margin: [0, 22, 0, 0],
  
                  // 		bold:'true',
                  alignment: 'center',
                  layout: 'verticalAlign',
                  border: [1, 0, 1, 1],
                  style: 'small',
  
                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
                {
                  table: {
  
                    widths: ['31.6%', '68.8%'],
  
                    body: [
  
                      // Ground under vehicle free of leaked fluids?
                      [
  
                        {
                          text: 'Seat belts?',
                          fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.seatBelt ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.seatBelt ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.seatBelt ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.seatBelt ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.seatBelt ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.seatBelt ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.seatBelt ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.seatBelt ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.seatBelt ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.seatBelt ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.seatBelt ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.seatBelt ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.seatBelt ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.seatBelt ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
                      ],
                      // 	Auto body free of new damage?
                      [
                        {
                          text: 'Seats hazard-free (tears, loose armrests)?',
                          fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.seatHazard ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.seatHazard ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.seatHazard ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.seatHazard ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.seatHazard ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.seatHazard ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.seatHazard ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.seatHazard ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.seatHazard ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.seatHazard ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.seatHazard ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.seatHazard ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.seatHazard ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.seatHazard ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
  
                      ],
                      // 	Clean windows and mirrors?
                      [
                        {
                          text: 'Floor free of hazards?',
                          fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.floorHazard ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.floorHazard ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.floorHazard ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.floorHazard ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.floorHazard ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.floorHazard ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.floorHazard ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.floorHazard ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.floorHazard ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.floorHazard ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.floorHazard ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.floorHazard ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.floorHazard ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.floorHazard ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
  
                      ],
                      // 	Windshield wipers/washers appear OK?
                      [
                        {
                          text: 'Clean interior?',
                          fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.clean ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.clean ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.clean ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.clean ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.clean ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.clean ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.clean ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.clean ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.clean ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.clean ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.clean ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.clean ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.clean ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.clean ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
                      ],
  
                      [
                        {
                          text: 'Mirrors adjusted properly?',
                          fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.mirrorsAdjustedProperly ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.mirrorsAdjustedProperly ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.mirrorsAdjustedProperly ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.mirrorsAdjustedProperly ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.mirrorsAdjustedProperly ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.mirrorsAdjustedProperly ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.mirrorsAdjustedProperly ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.mirrorsAdjustedProperly ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.mirrorsAdjustedProperly ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.mirrorsAdjustedProperly ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.mirrorsAdjustedProperly ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.mirrorsAdjustedProperly ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.mirrorsAdjustedProperly ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.mirrorsAdjustedProperly ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
                      ],
  
                      [
                        {
                          text: 'Doors operate from inside and outside?',
                          fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.doorOperational ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.doorOperational ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.doorOperational ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.doorOperational ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.doorOperational ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.doorOperational ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.doorOperational ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.doorOperational ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.doorOperational ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.doorOperational ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.doorOperational ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.doorOperational ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.doorOperational ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.doorOperational ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
                      ],
  
                      [
                        {
                          text: 'Door locks?',
                          fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.doorLock ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.doorLock ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.doorLock ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.doorLock ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.doorLock ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.doorLock ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.doorLock ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.doorLock ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.doorLock ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.doorLock ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.doorLock ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.doorLock ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.doorLock ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.doorLock ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
                      ],
  
                      [
                        {
                          text: 'Gauges? (e.g., oil, fuel, temp.)',
                          fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.gauges ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.gauges ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.gauges ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.gauges ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.gauges ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.gauges ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.gauges ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.gauges ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.gauges ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.gauges ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.gauges ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.gauges ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.gauges ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.gauges ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
                      ],
  
                      [
                        {
                          text: 'Fuel level adequate?',
                          fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.fuelLevel ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.fuelLevel ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.fuelLevel ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.fuelLevel ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.fuelLevel ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.fuelLevel ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.fuelLevel ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.fuelLevel ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.fuelLevel ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.fuelLevel ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.fuelLevel ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.fuelLevel ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.fuelLevel ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.fuelLevel ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
                      ],
  
                      [
                        {
                          text: 'No warning lights (e.g., check brakes) lit?',
                          fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.warningLight ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.warningLight ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.warningLight ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.warningLight ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.warningLight ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.warningLight ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.warningLight ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.warningLight ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.warningLight ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.warningLight ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.warningLight ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.warningLight ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.warningLight ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.warningLight ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
                      ],
  
                      [
                        {
                          text: '2-way communication device? (e.g., radio/cell)',
                          fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.comms ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.comms ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.comms ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.comms ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.comms ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.comms ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.comms ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.comms ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.comms ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.comms ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.comms ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.comms ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.comms ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.comms ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
                      ],
  
                      [
                        {
                          text: 'Horn',
                          fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.horn ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.horn ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.horn ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.horn ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.horn ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.horn ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.horn ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.horn ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.horn ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.horn ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.horn ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.horn ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.horn ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.horn ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
                      ],
  
                      [
                        {
                          text: 'Back-up alarm (if equipped)?',
                          fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.backAlarm ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.backAlarm ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.backAlarm ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.backAlarm ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.backAlarm ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.backAlarm ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.backAlarm ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.backAlarm ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.backAlarm ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.backAlarm ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.backAlarm ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.backAlarm ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.backAlarm ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.backAlarm ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
                      ],
  
  
                      [
                        {
                          text: 'Brakes',
                          fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.brake ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.brake ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.brake ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.brake ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.brake ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.brake ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.brake ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.brake ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.brake ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.brake ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.brake ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.brake ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.brake ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.brake ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
                      ],
  
                      [
                        {
                          text: 'Heater, defroster, and AC?',
                          fillColor: '#fecc9d',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
                        {
                          table: {
  
                            widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                            body: [
  
  
                              [
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.hdAC ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('0') ? (days['0'].interior.hdAC ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.hdAC ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('1') ? (days['1'].interior.hdAC ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.hdAC ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('2') ? (days['2'].interior.hdAC ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.hdAC ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('3') ? (days['3'].interior.hdAC ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.hdAC ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('4') ? (days['4'].interior.hdAC ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.hdAC ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('5') ? (days['5'].interior.hdAC ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#f1d5c2',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
  
                                {
                                  table: {
                                    widths: ['50%', '50%'],
  
                                    body: [
                                      [{
  
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.hdAC ? '\uf00c' : '') : ' ',
                                        border: [0, 0, 1, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      {
                                        text: days.hasOwnProperty('6') ? (days['6'].interior.hdAC ? '' : '\uf00c') : ' ',
                                        border: [0, 0, 0, 0],
                                        style: ['small', 'fontAwesome']
                                      },
                                      ],
  
                                    ]
                                  },
  
                                  // 		text: '_ _ _ , _ _ _',
                                  fillColor: '#b4d6fe',
                                  margin: [0, -3, 0, -3],
                                  padding: [0, 0, 0, 0],
                                  border: [0, 0, 1, 1],
                                  style: 'small',
                                  borderColor: ['#353935', '#353935', '#353935', '#353935']
                                },
                              ],
  
  
                            ]
                          },
                          margin: [-4, -4, -4, -4],
                          border: [0, 0, 0, 0]
                        },
  
                      ],
  
                    ]
                  },
                  margin: [-4, -4, -4, -4],
                  border: [0, 0, 0, 0]
                },
  
              ],
  
  
            ]
          },
          margin: [0, 0, 0, 0],
        },
        // 		{text:'', pageBreak: 'after'},
        // 		----Light working properly---
        {...lights(days)},
  
        // If equipped WHEELCHAIR LIFT and RAMP APPEAR OK?
        {...wheelchair(days)},
  
        // 		------Signatures----
        {
          table: {
            widths: ['20%', '80%'],
            //   border: [true, true, true, true],
            body: [
  
  
              [
  
                {
                  text: 'ATTESTATION: I hereby verify that the inspection findings above are accurate.',
                  fillColor: '#cdcdcd',
                  margin: [0, 10, 0, 0],
  
                  // 		bold:'true',
                  // 			alignment: 'center',
                  // 		layout: 'verticalAlign',
                  // border: [1, 1, 1, 1],
                  style: 'small',
  
                  // 			borderColor: ['#353935', '#353935', '#353935', '#353935']
                },
  
                {
                  table: {
  
                    widths: ['100%'],
  
                    body: [
  
  
                      [
  
                        {
                          text: data[0].attestation.name,
                          fillColor: '#f1f4ff',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 1, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
  
  
                      ],
                      [
  
                        {
                          text: '(PRINT NAME) ',
                          // 		fillColor: '#f1f4ff',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 1, 1, 0],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
  
  
                      ],
  
                      [
  
                        {
                          image: 'signature',
                          width: 50,
                          // 		fillColor: '#f1f4ff',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 0, 1, 0],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
  
  
                      ],
                      [
  
                        {
                          text: '(SIGNATURE)',
                          // 		fillColor: '#f1f4ff',
  
                          // 		bold:'true',
                          // 		alignment: 'center',
                          margin: [0, 0, 0, 0],
                          border: [0, 1, 1, 1],
                          style: 'small',
  
                          borderColor: ['#353935', '#353935', '#353935', '#353935']
                        },
  
  
                      ],
  
  
                    ]
                  },
                  margin: [-4, -3, -4, -3],
                  border: [0, 0, 0, 0]
                },
  
              ],
  
  
            ]
          },
          layout: {
  
  
          },
          margin: [0, 10, 0, 0],
        },
  
        // ------- Signature section end ----
  
      ],
  
      styles: {
        small: {
          fontSize: 6,
          font: 'Roboto'
        },
        large: {
          fontSize: 12
        },
        fontAwesome: {
          // fontSize: 8,
          font: 'FontAwesome'
        }
      },
  
      images: {
        // signature: 'data:image/png;base64,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',
        signature: await urlToBase64(data[0].attestation.signature)
      }
    }
  }

function lights(days) {
  return {
    table: {
      widths: ['10.4%', '89.6%'],
      body: [
        [
          {
            text: 'LIGHTS WORKING PROPERLY?',
            // 			fillColor: '#fecc9d',
            margin: [0, 30, 0, 0],

            // 		bold:'true',
            alignment: 'center',
            layout: 'verticalAlign',
            border: [1, 0, 1, 1],
            style: 'small',

            borderColor: ['#353935', '#353935', '#353935', '#353935']
          },

          {
            table: {

              widths: ['31.6%', '68.8%'],

              body: [

                // Ground under vehicle free of leaked fluids?
                [

                  {
                    text: 'Each headlight (high & low beam)?',
                    // 		fillColor: '#fecc9d',

                    // 		bold:'true',
                    // 		alignment: 'center',
                    margin: [0, 0, 0, 0],
                    border: [0, 0, 1, 1],
                    style: 'small',

                    borderColor: ['#353935', '#353935', '#353935', '#353935']
                  },
                  {
                    table: {

                      widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                      body: [


                        [

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('0') ? (days['0'].lights.headLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('0') ? (days['0'].lights.headLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('1') ? (days['1'].lights.headLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('1') ? (days['1'].lights.headLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1f4ff',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('2') ? (days['2'].lights.headLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('2') ? (days['2'].lights.headLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('3') ? (days['3'].lights.headLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('3') ? (days['3'].lights.headLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1f4ff',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('4') ? (days['4'].lights.headLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('4') ? (days['4'].lights.headLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('5') ? (days['5'].lights.headLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('5') ? (days['5'].lights.headLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1f4ff',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('6') ? (days['6'].lights.headLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('6') ? (days['6'].lights.headLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },
                        ],


                      ]
                    },
                    margin: [-4, -4, -4, -4],
                    border: [0, 0, 0, 0]
                  },

                ],
                // 	Auto body free of new damage?
                [
                  {
                    text: 'Each tail light and marker light?',
                    // 		fillColor: '#fecc9d',

                    // 		bold:'true',
                    // 		alignment: 'center',
                    margin: [0, 0, 0, 0],
                    border: [0, 0, 1, 1],
                    style: 'small',

                    borderColor: ['#353935', '#353935', '#353935', '#353935']
                  },
                  {
                    table: {

                      widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                      body: [


                        [

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('0') ? (days['0'].lights.tailLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('0') ? (days['0'].lights.tailLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('1') ? (days['1'].lights.tailLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('1') ? (days['1'].lights.tailLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1f4ff',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('2') ? (days['2'].lights.tailLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('2') ? (days['2'].lights.tailLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('3') ? (days['3'].lights.tailLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('3') ? (days['3'].lights.tailLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1f4ff',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('4') ? (days['4'].lights.tailLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('4') ? (days['4'].lights.tailLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('5') ? (days['5'].lights.tailLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('5') ? (days['5'].lights.tailLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1f4ff',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('6') ? (days['6'].lights.tailLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('6') ? (days['6'].lights.tailLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },
                        ],


                      ]
                    },
                    margin: [-4, -4, -4, -4],
                    border: [0, 0, 0, 0]
                  },


                ],

                [
                  {
                    text: 'Each brake light?',
                    // 		fillColor: '#fecc9d',

                    // 		bold:'true',
                    // 		alignment: 'center',
                    margin: [0, 0, 0, 0],
                    border: [0, 0, 1, 1],
                    style: 'small',

                    borderColor: ['#353935', '#353935', '#353935', '#353935']
                  },
                  {
                    table: {

                      widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                      body: [


                        [

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('0') ? (days['0'].lights.brakeLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('0') ? (days['0'].lights.brakeLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('1') ? (days['1'].lights.brakeLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('1') ? (days['1'].lights.brakeLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1f4ff',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('2') ? (days['2'].lights.brakeLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('2') ? (days['2'].lights.brakeLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('3') ? (days['3'].lights.brakeLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('3') ? (days['3'].lights.brakeLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1f4ff',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('4') ? (days['4'].lights.brakeLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('4') ? (days['4'].lights.brakeLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('5') ? (days['5'].lights.brakeLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('5') ? (days['5'].lights.brakeLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1f4ff',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('6') ? (days['6'].lights.brakeLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('6') ? (days['6'].lights.brakeLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },
                        ],


                      ]
                    },
                    margin: [-4, -4, -4, -4],
                    border: [0, 0, 0, 0]
                  },


                ],

                [
                  {
                    text: 'Each turn signal?',
                    // 		fillColor: '#fecc9d',

                    // 		bold:'true',
                    // 		alignment: 'center',
                    margin: [0, 0, 0, 0],
                    border: [0, 0, 1, 1],
                    style: 'small',

                    borderColor: ['#353935', '#353935', '#353935', '#353935']
                  },
                  {
                    table: {

                      widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                      body: [


                        [

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('0') ? (days['0'].lights.turnLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('0') ? (days['0'].lights.turnLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('1') ? (days['1'].lights.turnLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('1') ? (days['1'].lights.turnLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1f4ff',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('2') ? (days['2'].lights.turnLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('2') ? (days['2'].lights.turnLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('3') ? (days['3'].lights.turnLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('3') ? (days['3'].lights.turnLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1f4ff',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('4') ? (days['4'].lights.turnLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('4') ? (days['4'].lights.turnLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('5') ? (days['5'].lights.turnLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('5') ? (days['5'].lights.turnLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1f4ff',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('6') ? (days['6'].lights.turnLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('6') ? (days['6'].lights.turnLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },
                        ],


                      ]
                    },
                    margin: [-4, -4, -4, -4],
                    border: [0, 0, 0, 0]
                  },


                ],

                [
                  {
                    text: 'Each back-up light?',
                    // 		fillColor: '#fecc9d',

                    // 		bold:'true',
                    // 		alignment: 'center',
                    margin: [0, 0, 0, 0],
                    border: [0, 0, 1, 1],
                    style: 'small',

                    borderColor: ['#353935', '#353935', '#353935', '#353935']
                  },
                  {
                    table: {

                      widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                      body: [


                        [

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('0') ? (days['0'].lights.backupLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('0') ? (days['0'].lights.backupLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('1') ? (days['1'].lights.backupLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('1') ? (days['1'].lights.backupLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1f4ff',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('2') ? (days['2'].lights.backupLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('2') ? (days['2'].lights.backupLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('3') ? (days['3'].lights.backupLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('3') ? (days['3'].lights.backupLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1f4ff',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('4') ? (days['4'].lights.backupLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('4') ? (days['4'].lights.backupLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('5') ? (days['5'].lights.backupLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('5') ? (days['5'].lights.backupLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1f4ff',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('6') ? (days['6'].lights.backupLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('6') ? (days['6'].lights.backupLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },
                        ],


                      ]
                    },
                    margin: [-4, -4, -4, -4],
                    border: [0, 0, 0, 0]
                  },


                ],

                [
                  {
                    text: 'Hazard lights (front and rear)?',
                    // 		fillColor: '#fecc9d',

                    // 		bold:'true',
                    // 		alignment: 'center',
                    margin: [0, 0, 0, 0],
                    border: [0, 0, 1, 1],
                    style: 'small',

                    borderColor: ['#353935', '#353935', '#353935', '#353935']
                  },
                  {
                    table: {

                      widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                      body: [


                        [

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('0') ? (days['0'].lights.hazardLight ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('0') ? (days['0'].lights.hazardLight ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('1') ? (days['1'].lights.hazardLight ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('1') ? (days['1'].lights.hazardLight ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1f4ff',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('2') ? (days['2'].lights.hazardLight ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('2') ? (days['2'].lights.hazardLight ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('3') ? (days['3'].lights.hazardLight ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('3') ? (days['3'].lights.hazardLight ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1f4ff',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('4') ? (days['4'].lights.hazardLight ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('4') ? (days['4'].lights.hazardLight ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('5') ? (days['5'].lights.hazardLight ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('5') ? (days['5'].lights.hazardLight ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1f4ff',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('6') ? (days['6'].lights.hazardLight ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('6') ? (days['6'].lights.hazardLight ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },
                        ],


                      ]
                    },
                    margin: [-4, -4, -4, -4],
                    border: [0, 0, 0, 0]
                  },


                ],

                [
                  {
                    text: 'License plate light?',
                    // 		fillColor: '#fecc9d',

                    // 		bold:'true',
                    // 		alignment: 'center',
                    margin: [0, 0, 0, 0],
                    border: [0, 0, 1, 1],
                    style: 'small',

                    borderColor: ['#353935', '#353935', '#353935', '#353935']
                  },
                  {
                    table: {

                      widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                      body: [


                        [

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('0') ? (days['0'].lights.liPlateLight ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('0') ? (days['0'].lights.liPlateLight ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('1') ? (days['1'].lights.liPlateLight ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('1') ? (days['1'].lights.liPlateLight ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1f4ff',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('2') ? (days['2'].lights.liPlateLight ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('2') ? (days['2'].lights.liPlateLight ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('3') ? (days['3'].lights.liPlateLight ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('3') ? (days['3'].lights.liPlateLight ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1f4ff',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('4') ? (days['4'].lights.liPlateLight ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('4') ? (days['4'].lights.liPlateLight ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('5') ? (days['5'].lights.liPlateLight ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('5') ? (days['5'].lights.liPlateLight ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1f4ff',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('6') ? (days['6'].lights.liPlateLight ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('6') ? (days['6'].lights.liPlateLight ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },
                        ],


                      ]
                    },
                    margin: [-4, -4, -4, -4],
                    border: [0, 0, 0, 0]
                  },


                ],

                [
                  {
                    text: 'Interior lights?',
                    // 		fillColor: '#fecc9d',

                    // 		bold:'true',
                    // 		alignment: 'center',
                    margin: [0, 0, 0, 0],
                    border: [0, 0, 1, 1],
                    style: 'small',

                    borderColor: ['#353935', '#353935', '#353935', '#353935']
                  },
                  {
                    table: {

                      widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                      body: [


                        [

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('0') ? (days['0'].lights.intLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('0') ? (days['0'].lights.intLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('1') ? (days['1'].lights.intLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('1') ? (days['1'].lights.intLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1f4ff',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('2') ? (days['2'].lights.intLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('2') ? (days['2'].lights.intLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('3') ? (days['3'].lights.intLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('3') ? (days['3'].lights.intLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1f4ff',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('4') ? (days['4'].lights.intLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('4') ? (days['4'].lights.intLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('5') ? (days['5'].lights.intLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('5') ? (days['5'].lights.intLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1f4ff',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('6') ? (days['6'].lights.intLights ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('6') ? (days['6'].lights.intLights ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },
                        ],


                      ]
                    },
                    margin: [-4, -4, -4, -4],
                    border: [0, 0, 0, 0]
                  },


                ],

              ]
            },
            margin: [-4, -2, -4, -4],
            border: [0, 0, 0, 0]
          },

        ],


      ]
    },
    margin: [0, 0, 0, 0],
  }
}

function wheelchair(days) {
  return {
    table: {

      widths: ['10.4%', '89.6%'],
      body: [


        [

          {
            text: 'If equipped WHEELCHAIR LIFT and RAMP APPEAR OK?',
            fillColor: '#fecc9d',
            margin: [0, 12, 0, 0],

            // 		bold:'true',
            alignment: 'center',
            layout: 'verticalAlign',
            border: [1, 0, 1, 1],
            style: 'small',

            borderColor: ['#353935', '#353935', '#353935', '#353935']
          },

          {
            table: {

              widths: ['31.6%', '68.8%'],

              body: [

                // Ground under vehicle free of leaked fluids?
                [

                  {
                    text: 'Operates through complete cycle?',
                    fillColor: '#fecc9d',

                    // 		bold:'true',
                    // 		alignment: 'center',
                    margin: [0, 0, 0, 0],
                    border: [0, 0, 1, 1],
                    style: 'small',

                    borderColor: ['#353935', '#353935', '#353935', '#353935']
                  },
                  {
                    table: {

                      widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                      body: [


                        [

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('0') ? (days['0'].wheelChairRamp.operational ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('0') ? (days['0'].wheelChairRamp.operational ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('1') ? (days['1'].wheelChairRamp.operational ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('1') ? (days['1'].wheelChairRamp.operational ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1d5c2',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('2') ? (days['2'].wheelChairRamp.operational ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('2') ? (days['2'].wheelChairRamp.operational ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('3') ? (days['3'].wheelChairRamp.operational ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('3') ? (days['3'].wheelChairRamp.operational ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1d5c2',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('4') ? (days['4'].wheelChairRamp.operational ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('4') ? (days['4'].wheelChairRamp.operational ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('5') ? (days['5'].wheelChairRamp.operational ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('5') ? (days['5'].wheelChairRamp.operational ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1d5c2',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('6') ? (days['6'].wheelChairRamp.operational ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('6') ? (days['6'].wheelChairRamp.operational ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },
                        ],


                      ]
                    },
                    margin: [-4, -4, -4, -4],
                    border: [0, 0, 0, 0]
                  },

                ],
                // 	Auto body free of new damage?
                [
                  {
                    text: 'Properly secured to vehicle?',
                    fillColor: '#fecc9d',

                    // 		bold:'true',
                    // 		alignment: 'center',
                    margin: [0, 0, 0, 0],
                    border: [0, 0, 1, 1],
                    style: 'small',

                    borderColor: ['#353935', '#353935', '#353935', '#353935']
                  },
                  {
                    table: {

                      widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                      body: [


                        [

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('0') ? (days['0'].wheelChairRamp.securedToVehicle ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('0') ? (days['0'].wheelChairRamp.securedToVehicle ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('1') ? (days['1'].wheelChairRamp.securedToVehicle ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('1') ? (days['1'].wheelChairRamp.securedToVehicle ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1d5c2',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('2') ? (days['2'].wheelChairRamp.securedToVehicle ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('2') ? (days['2'].wheelChairRamp.securedToVehicle ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('3') ? (days['3'].wheelChairRamp.securedToVehicle ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('3') ? (days['3'].wheelChairRamp.securedToVehicle ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1d5c2',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('4') ? (days['4'].wheelChairRamp.securedToVehicle ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('4') ? (days['4'].wheelChairRamp.securedToVehicle ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('5') ? (days['5'].wheelChairRamp.securedToVehicle ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('5') ? (days['5'].wheelChairRamp.securedToVehicle ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1d5c2',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('6') ? (days['6'].wheelChairRamp.securedToVehicle ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('6') ? (days['6'].wheelChairRamp.securedToVehicle ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },
                        ],


                      ]
                    },
                    margin: [-4, -4, -4, -4],
                    border: [0, 0, 0, 0]
                  },


                ],
                // 	Clean windows and mirrors?
                [
                  {
                    text: 'Proper number of restraints?',
                    fillColor: '#fecc9d',

                    // 		bold:'true',
                    // 		alignment: 'center',
                    margin: [0, 0, 0, 0],
                    border: [0, 0, 1, 1],
                    style: 'small',

                    borderColor: ['#353935', '#353935', '#353935', '#353935']
                  },
                  {
                    table: {

                      widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                      body: [


                        [

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('0') ? (days['0'].wheelChairRamp.noOfBelts ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('0') ? (days['0'].wheelChairRamp.noOfBelts ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('1') ? (days['1'].wheelChairRamp.noOfBelts ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('1') ? (days['1'].wheelChairRamp.noOfBelts ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1d5c2',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('2') ? (days['2'].wheelChairRamp.noOfBelts ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('2') ? (days['2'].wheelChairRamp.noOfBelts ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('3') ? (days['3'].wheelChairRamp.noOfBelts ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('3') ? (days['3'].wheelChairRamp.noOfBelts ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1d5c2',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('4') ? (days['4'].wheelChairRamp.noOfBelts ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('4') ? (days['4'].wheelChairRamp.noOfBelts ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('5') ? (days['5'].wheelChairRamp.noOfBelts ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('5') ? (days['5'].wheelChairRamp.noOfBelts ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1d5c2',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('6') ? (days['6'].wheelChairRamp.noOfBelts ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('6') ? (days['6'].wheelChairRamp.noOfBelts ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },
                        ],


                      ]
                    },
                    margin: [-4, -4, -4, -4],
                    border: [0, 0, 0, 0]
                  },


                ],
                // 	Windshield wipers/washers appear OK?
                [
                  {
                    text: 'Free of physical damage or leaking fluid?',
                    fillColor: '#fecc9d',

                    // 		bold:'true',
                    // 		alignment: 'center',
                    margin: [0, 0, 0, 0],
                    border: [0, 0, 1, 1],
                    style: 'small',

                    borderColor: ['#353935', '#353935', '#353935', '#353935']
                  },
                  {
                    table: {

                      widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                      body: [


                        [

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('0') ? (days['0'].wheelChairRamp.freeOfDamage ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('0') ? (days['0'].wheelChairRamp.freeOfDamage ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('1') ? (days['1'].wheelChairRamp.freeOfDamage ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('1') ? (days['1'].wheelChairRamp.freeOfDamage ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1d5c2',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('2') ? (days['2'].wheelChairRamp.freeOfDamage ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('2') ? (days['2'].wheelChairRamp.freeOfDamage ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('3') ? (days['3'].wheelChairRamp.freeOfDamage ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('3') ? (days['3'].wheelChairRamp.freeOfDamage ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1d5c2',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('4') ? (days['4'].wheelChairRamp.freeOfDamage ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('4') ? (days['4'].wheelChairRamp.freeOfDamage ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('5') ? (days['5'].wheelChairRamp.freeOfDamage ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('5') ? (days['5'].wheelChairRamp.freeOfDamage ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1d5c2',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('6') ? (days['6'].wheelChairRamp.freeOfDamage ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('6') ? (days['6'].wheelChairRamp.freeOfDamage ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },
                        ],


                      ]
                    },
                    margin: [-4, -4, -4, -4],
                    border: [0, 0, 0, 0]
                  },

                ],

                [
                  {
                    text: 'Free of dirt, mud, gravel, salt, etc.?',
                    fillColor: '#fecc9d',

                    // 		bold:'true',
                    // 		alignment: 'center',
                    margin: [0, 0, 0, 0],
                    border: [0, 0, 1, 1],
                    style: 'small',

                    borderColor: ['#353935', '#353935', '#353935', '#353935']
                  },
                  {
                    table: {

                      widths: ['14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%', '14.28%'],
                      body: [


                        [

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('0') ? (days['0'].wheelChairRamp.freeOfDirt ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('0') ? (days['0'].wheelChairRamp.freeOfDirt ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('1') ? (days['1'].wheelChairRamp.freeOfDirt ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('1') ? (days['1'].wheelChairRamp.freeOfDirt ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1d5c2',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('2') ? (days['2'].wheelChairRamp.freeOfDirt ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('2') ? (days['2'].wheelChairRamp.freeOfDirt ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('3') ? (days['3'].wheelChairRamp.freeOfDirt ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('3') ? (days['3'].wheelChairRamp.freeOfDirt ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1d5c2',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('4') ? (days['4'].wheelChairRamp.freeOfDirt ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('4') ? (days['4'].wheelChairRamp.freeOfDirt ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('5') ? (days['5'].wheelChairRamp.freeOfDirt ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('5') ? (days['5'].wheelChairRamp.freeOfDirt ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#f1d5c2',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },

                          {
                            table: {
                              widths: ['50%', '50%'],

                              body: [
                                [{

                                  text: days.hasOwnProperty('6') ? (days['6'].wheelChairRamp.freeOfDirt ? '\uf00c' : '') : ' ',
                                  border: [0, 0, 1, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                {
                                  text: days.hasOwnProperty('6') ? (days['6'].wheelChairRamp.freeOfDirt ? '' : '\uf00c') : ' ',
                                  border: [0, 0, 0, 0],
                                  style: ['small', 'fontAwesome']
                                },
                                ],

                              ]
                            },

                            // 		text: '_ _ _ , _ _ _',
                            fillColor: '#b4d6fe',
                            margin: [0, -3, 0, -3],
                            padding: [0, 0, 0, 0],
                            border: [0, 0, 1, 1],
                            style: 'small',
                            borderColor: ['#353935', '#353935', '#353935', '#353935']
                          },
                        ],


                      ]
                    },
                    margin: [-4, -4, -4, -4],
                    border: [0, 0, 0, 0]
                  },

                ],

              ]
            },
            margin: [-4, -4, -4, -4],
            border: [0, 0, 0, 0]
          },

        ],


      ]
    },
    margin: [0, 0, 0, 0],
  }
}